import type {
  MhaStatus,
  S132Period,
  S132Record,
} from "@thalamos/aspire-common";
import { s132SectionsOwingDuty } from "@thalamos/aspire-common";

import type { S132SectionChoice } from "./RecordS132AttemptDialog.js";
import { ukLocalFormatDateTime } from "~/util.js";

export const periodLabel = (period: S132Period): string =>
  `${period.section} from ${ukLocalFormatDateTime(period.start)}${
    period.end ? ` to ${ukLocalFormatDateTime(period.end)}` : ""
  }`;

export const s132PeriodChoice = (period: S132Period): S132SectionChoice => ({
  section: period.section,
  label: `${periodLabel(period)}${period.current ? " (current)" : ""}`,
});

/**
 * Sections the Record dialog offers: one per section the patient has held,
 * newest first, since the attempt is matched to a period by its date, then
 * every other section that owes the duty. The section explained may not have
 * been recorded in eMHA yet, even while another is current, as when a Section 4
 * becomes a Section 2; the attempt counts once it is.
 */
export function s132SectionChoices(
  record: S132Record | undefined,
): S132SectionChoice[] {
  const choices = new Map<MhaStatus, S132SectionChoice>();
  for (const period of record?.periods ?? []) {
    if (choices.has(period.section)) continue;
    choices.set(period.section, s132PeriodChoice(period));
  }
  for (const section of s132SectionsOwingDuty) {
    if (choices.has(section)) continue;
    choices.set(section, {
      section,
      label: `${section} (not yet recorded in eMHA)`,
    });
  }
  return [...choices.values()];
}
